import { icons } from '../../../images';
import React, { useRef } from 'react';
import FloatingSelect from '../../../components/FloatingSelect.js';
import { useSelector } from 'react-redux';
import { inboxMarkAsOptions } from '../store/inboxScreenSelectors.js';
import MessageUTMBubbles from './MessageUTMBubbles.js';
import { setInboxMessageStatus } from '../store/inboxScreenActions.js';
import getInboxMessageSnippet from '../lib/getInboxMessageSnippet.js';
import SVG from '../../../images/svg/SVG.js';
import { RecordBeingViewedInitials } from 'components/RecordBeingViewedInitials';
import { useRecordBeingViewed } from 'hooks';

const Message = ({ message, onClick, onReadOrUnreadToggleClick }) => {
  const markAsRef = useRef(null);
  const markAsOptions = useSelector(inboxMarkAsOptions(message.statusId));

  const snippet = getInboxMessageSnippet(message);
  const readUnreadTitle = !message.isRead ? 'Mark as Read' : 'Mark as Unread';
  const profileImageUrl = message.threadMeta.profile_image_url;

  const platform = message.message.platform || {};
  const detailType = ['facebookmessenger'].includes(platform.code) ? platform.code : message.type;
  const isLead = !!message.leadId;

  const recordBeingViewed = useRecordBeingViewed(message.leadId ? message.leadId : message.id);

  const handleMarkAsChange = (option) => {
    setInboxMessageStatus(message, option.id);
  };

  return (
    <div className={`inbox-message ${message.active ? 'active' : ''} ${detailType} ${isLead ? 'lead' : ''} ${recordBeingViewed ? 'record-being-viewed' : ''}`} onClick={onClick}>
      <div className="icon-wrapper">
        {profileImageUrl && (
          <div className="profile-image">
            <img alt="Profile" src={profileImageUrl} />
          </div>
        )}
        {!profileImageUrl && (
          <div className="icon">
            {message.svg && <SVG type={'image'} icon={message.svg} />}
            {isLead && (
              <span className={`lead-icon`}>
                <SVG icon={'Person'} />
              </span>
            )}
          </div>
        )}
      </div>
      <div className="content-wrapper">
        <div className="heading">
          {message.name} {recordBeingViewed && <RecordBeingViewedInitials styles={{ marginLeft: 5, marginBottom: 3 }} id={message.leadId ? message.leadId : message.id} invert={message.active} />}
        </div>
        <div className="subheading">
          {message.serviceLocationName && <span>{message.serviceLocationName}</span>}
          <span className="comment" data-title={message.fullDate}>
            {message.date}
          </span>
        </div>
        <div className="snippet">{snippet}</div>
        <div className="controls">
          {!isLead && (
            <div className={'mark-as'} data-title={'Mark As'}>
              <img src={icons['archive']} ref={markAsRef} alt={'Mark As'} />
              <FloatingSelect triggers={[(markAsRef || {}).current]} options={markAsOptions} onChange={handleMarkAsChange} />
            </div>
          )}
          {isLead && (
            <div className={`read-unread-bubble ${message.isRead ? 'read' : 'unread'}`} onClick={(e) => onReadOrUnreadToggleClick(e, message)} data-title={readUnreadTitle}>
              <div />
            </div>
          )}
        </div>
        {!message.leadId && <MessageUTMBubbles message={message} />}
      </div>
    </div>
  );
};

export default Message;
